import { ReturoSeal } from 'components/shop-reception/mobile/interfaces'

const toSealList = (noticeId: number, seals: ReturoSeal[]) =>
  seals.map(seal => ({
    sealCode: seal.sealCode,
    scanStatus: 'DELIVERED',
    noticeId,
    materialType: seal.materialType
  }))

export const toNoticesSealsPayload = (noticeId: number, seals: ReturoSeal[]) => ({
  id: noticeId,
  sealList: toSealList(noticeId, seals)
})
